import Modal from "@ignitesales/react-modal";
import classnames from "classnames";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

const ConfirmDeleteModal = ({ active, onClose, onSubmit, productToDelete, className }) => {
  const intl = useIntl();
  const classes = classnames(className, "confirmDelete");

  return productToDelete !== null && (
    <Modal
      show={active}
      className={classes}
      onClose={onClose}
      nodeId="root"
      closeBtn={
        <i className="fa fa-times" role="img" aria-label="Close" />
      }
    >
      <div className="cart-confirm-delete-message">
        <div className="cart-confirm-delete-text">
          <FormattedMessage id="cart.confirmDelete.message" />
        </div>
        <div className="cart-confirm-delete-name">
          <FormattedMessage id={`${productToDelete}.name`} />?
        </div>
      </div>
      <div className="cart-confirm-delete-buttons">
        <button className="btn btn-secondary" onClick={onClose}>
          <FormattedMessage id="cart.noConfirmDelete.button" />
        </button>
        <button className="btn btn-primary" onClick={onSubmit}>
          <FormattedMessage id="cart.confirmDelete.button" />
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
